import { z } from 'zod'

export const productTypeSchema = z.enum(['1', '2', '3', '4', '5', '6', '7'])

export type ProductType = z.infer<typeof productTypeSchema>

export const productTypeNameSchema = z.enum([
  'Teléfono',
  'Laptop',
  'Apple',
  'Otros',
  'Motor',
  'Miscelánea'
])

export const supplierNamesSchema = z.enum([
  'Nuovo',
  'Equality',
  'Apple',
  'Otros',
  'Automotriz',
  'Mundo'
])

export const supplierCodeSchema = z.enum([
  'NVO',
  'EQU',
  'APL',
  'OTR',
  'AUT',
  'MUN'
])
